import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles(theme => ({
  formPanel: {
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    opacity: '0',
    visibility: 'hidden',
    inset: '0 0 0 0',
    zIndex: '100000',
    display: 'flex',
    flexDirection: 'row-reverse',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    transition: 'all 0.3s ease 0.4s',

    '&.is-active': {
      opacity: '1',
      visibility: 'visible',
      transitionDelay: '0s',

      '& [class^=formPanelInner]': {
        transform: 'translateX(0)',
        transitionDelay: '0.3s',
      },
    },
  },

  formPanelInner: {
    width: '100%',
    inset: '0 0 auto auto',
    transform: 'translateX(105%)',
    transition: 'transform 0.4s ease-in-out',

    '@media (min-width: 961px)': {
      width: 'max(960px, 50vw)',
    },
  },

  formPanelHeader: {
    display: 'grid',
    position: 'relative',
    boxSizing: 'border-box',
    minHeight: 'clamp(260px, 14vw, 600px)',
    alignItems: 'center',
    padding: '40px max(14%, 20px)',
    background: 'rgb(235,58,74)',
    background: 'linear-gradient(90deg, rgba(235,58,74,1) 0%, rgba(251,84,96,1) 100%)',
    color: 'white',

    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: '1',
      backgroundImage: 'url(/assets/images/thrifty-hero-isolated-min.png)',
      backgroundSize: 'cover',
      inset: '0 0 0 50%',
    },

    '& h2': {
      position: 'relative',
      zIndex: '2',
      fontFamily: 'TTRounds',
      fontWeight: '700',

      '& span': {
        display: 'block',
        fontFamily: 'TTRounds',
        lineHeight: '.9',
      },
    },

    '& p': {
      position: 'relative',
      zIndex: '2',
      fontFamily: 'TTRounds',
      fontWeight: '700',
    },
  },

  panelClose: {
    display: 'block',
    position: 'fixed',
    top: 0,
    right: 0,
    width: '50px',
    height: '50px',
    backgroundColor: 'transparent',
    transition: 'background-color 0.3s ease',
    zIndex: 5,
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'rgba(0,0,0,.3)',
    },

    '&:before, &:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: '40px',
      height: '1px',
      top: '25px',
      left: '5px',
      backgroundColor: 'white',
    },

    '&:before': {
      transform: 'rotate(45deg)',
    },

    '&:after': {
      transform: 'rotate(-45deg)',
    },
  },

  promoIntroduction: {
    '& h2': {
      fontSize: 'max(5vw, 24px)',
      '@media (min-width: 768px)': {
        fontSize: 'max(1.55vw, 35px)',
      },

      '& span': {
        fontWeight: '900',
        letterSpacing: '.015em',
        lineHeight: '.9',
        textTransform: 'uppercase',
        fontSize: 'max(10vw, 48px)',
        '@media (min-width: 768px)': {
          fontSize: 'max(3.5vw, 70px)',
        },
      },
    },

    '& p': {
      maxWidth: '24ch',
      fontSize: 'max(3.6vw, 18px)',
      '@media (min-width: 768px)': {
        fontSize: 'max(1vw, 22px)',
      },
    },
  },

  promoCompletion: {
    '& h2': {
      fontSize: 'max(5vw, 22px)',
      '@media (min-width: 768px)': {
        fontSize: 'max(1.25vw, 30px)',
      },

      '& span': {
        lineHeight: '1.6',
        fontSize: 'max(5vw, 30px)',
        '@media (min-width: 768px)': {
          fontSize: 'max(2vw, 40px)',
        },
      },
    },

    '& p': {
      maxWidth: '30ch',
      fontSize: 'max(2.8vw, 16px)',
      '@media (min-width: 768px)': {
        fontSize: 'max(1vw, 18px)',
      },
    },
  },

  formPanelMain: {
    padding: '40px max(14%, 20px)',
    backgroundColor: theme.colors.blue,
    color: 'white',
  },

  formPanelFooter: {
    backgroundColor: 'white',
  },

  benefitsContainer: {
    padding: 'max(40px, 5vh) max(8%, 20px)',
  },
  benefitsTitle: {
    fontSize: '32px',
    lineHeight: '42px',
    fontWeight: 700,
    fontFamily: 'TTRounds',
    textAlign: 'center',
    marginBottom: '30px',
    marginTop: 0,
  },
  benefitsItems: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '44px 20px',
  },
  benefitsItem: {
    textAlign: 'center',
    flex: '0 0 100%',
    maxWidth: '100%',

    '@media (min-width: 768px)': {
      flex: '0 0 40%',
      maxWidth: '40%',
    },
    '@media (min-width: 961px)': {
      flex: '0 0 28%',
      maxWidth: '28%',
    },
  },
  benefitsItemImage: {
    height: '80px',
    display: 'grid',
    alignItems: 'center',
    justifyContent: 'center',

    '& img': {
      width: '50px',
      height: '50px',
      objectFit: 'contain',
    },
  },
  benefitsItemTitle: {
    fontSize: '20px',
    maxWidth: '16ch',
    margin: '30px auto 1em',
    lineHeight: '28px',
    fontWeight: 700,
    fontFamily: 'TTRounds',
    textAlign: 'center',
    '@media (max-width: 750px)': {
      paddingTop: '13px',
    },
  },
  benefitsItemDetails: {
    fontSize: '17px',
    lineHeight: '22px',
    fontWeight: 400,
    fontFamily: 'AvenirNextLTPro',
    textAlign: 'center',
    maxWidth: '24ch',
    margin: '0 auto',
  },
}))